import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'

const Actions = {
  // INQ01 お問い合わせ送信
  postInquiry: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    return await axios
      .post(api.INQUIRY, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
